import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpUtilsService } from '../../_base/crud';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser, selectQvToken } from '../../auth';
import { environment } from '../../../../environments/environment';
import { of } from 'rxjs';

@Injectable()
export class QrveyService {
  private authToken;
  private companyId;
  private qrveyToken: string;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
    this.store.pipe(select(selectQvToken)).subscribe((res) => {
      if (res) {
        this.qrveyToken = res;
      }
    });
  }

  getPageGroups(appId) {
    const url = `${environment.QRVEY_ACCESS_MANAGER}/companies/${this.companyId}/qrvey/applications/${appId}/page_groups`;
    return this.http.get<any>(url);
  }

  getTeamsByApplication(appId) {
    const url = `${environment.QRVEY_ACCESS_MANAGER}/companies/${this.companyId}/qrvey/applications/${appId}/teams`;
    return this.http.get<any>(url);
  }

  createPageGroup(_pageGroup, appId) {
    const URL = `${environment.QRVEY_ACCESS_MANAGER}/companies/${this.companyId}/qrvey/applications/${appId}/page_groups`;
    return this.http.post(URL, _pageGroup);
  }

  updatePageGroup(_pageGroup, appId) {
    if (!_pageGroup.id) {
      return of(null);
    }
    const URL = `${environment.QRVEY_ACCESS_MANAGER}/companies/${this.companyId}/qrvey/applications/${appId}/page_groups/${_pageGroup.id}`;
    return this.http.put(URL, _pageGroup);
  }

  deletePageGroup(_pageGroup, appId) {
    if (!_pageGroup.id) {
      return of(null);
    }
    const URL = `${environment.QRVEY_ACCESS_MANAGER}/companies/${this.companyId}/qrvey/applications/${appId}/page_groups/${_pageGroup.id}`;
    return this.http.delete(URL);
  }

  getUsers(categorys) {
    if (categorys.length === 0) return of([]);
    let ids = '';
    categorys.forEach((element) => (ids = ids + '&category_ids=' + element));
    const params = new HttpParams({ fromString: ids });
    const url = `${environment.USER_BASE}/companies/${this.companyId}/categories/members?category_ids=${categorys[0]}`;
    return this.http.get<any>(url, { params });
  }

  getContacts(categorys, entityId) {
    if (categorys.length === 0) return of([]);
    let ids = '';
    categorys.forEach((element) => (ids = ids + '&category_ids=' + element));
    const params = new HttpParams({ fromString: ids + entityId });
    const url = `${environment.CORE_BASE}/companies/${this.companyId}/categories/members`;
    return this.http.get<any>(url, { params });
  }

  putCategoryAccess(_item, appId) {
    const URL = `${environment.QRVEY_ACCESS_MANAGER}/companies/${
      this.companyId
    }/qrvey/applications/${appId}/teams/${_item.id ? _item.id : _item.team_id}`;
    return this.http.put(URL, _item);
  }

  removeInternalAccess(appId, teamId, type) {
    const URL = `${environment.QRVEY_ACCESS_MANAGER}/companies/${this.companyId}/qrvey/applications/${appId}/teams/${teamId}?user_type=${type}`;
    return this.http.delete(URL);
  }

  getBlockUsers(appId) {
    const url = `${environment.QRVEY_ACCESS_MANAGER}/companies/${this.companyId}/qrvey/applications/${appId}/black_list`;
    return this.http.get<any>(url);
  }

  blockUsers(user, appId, type) {
    const URL = `${environment.QRVEY_ACCESS_MANAGER}/companies/${this.companyId}/qrvey/applications/${appId}/black_list`;
    const block = {
      user_type: type,
      user_id: user.id,
    };
    const users = [block];
    const body = {
      users,
    };
    return this.http.post(URL, body);
  }

  unblockUsers(teamMember, appId, type) {
    const URL = `${environment.QRVEY_ACCESS_MANAGER}/companies/${this.companyId}/qrvey/applications/${appId}/black_list/${teamMember.id}?user_type=${type}`;
    return this.http.delete(URL);
  }

  getPageBuilderToken(userId, appId, pageId) {
    let page = '';
    if (pageId && pageId !== '') {
      page = `&qrvey_page_id=${pageId}`;
    }
    const url = `${environment.QRVEY_ACCESS_MANAGER}/companies/${this.companyId}/qrvey/token?qrvey_user_id=${userId}&qrvey_app_id=${appId}${page}`;
    return this.http.get<any>(url);
  }

  getAllPagesFromQRVEY(appId, userId) {
    const httpHeaders = this.httpUtils.getHTTPHeadersformCSV(this.qrveyToken);
    const url = `${environment.QRVEY_DOMAIN}/devapi/v3/user/${userId}/app/${appId}/builder/page/?limit=1000`;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  deployPage(page, appId) {
    const URL = `${environment.QRVEY_ACCESS_MANAGER}/companies/${this.companyId}/qrvey/applications/${appId}/pages`;
    return this.http.post(URL, page);
  }
}
